import { Injectable } from '@angular/core';
import { RemoteErrorLoggingService } from '@app/shared/handlers/remote-error-logging.service';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  constructor(private remoteErrorLoggingService: RemoteErrorLoggingService) {}

  error(error: Error | string) {
    this.remoteErrorLoggingService.logError(error);
  }
}
